import React, { useState } from 'react';
import {
  useEmailTabContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/EmailTabContext';
import {
  EmailEditorSection,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections/EmailEditorSection';
import {
  AttachmentsSection,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections/AttachmentsSection';
import {
  TasksSection,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections/TasksSection';

export const ATTACHMENTS_SECTION = 'attachments';
export const PLANNER_TASKS_SECTION = 'planner-tasks';
export const MEMBER_TASKS_SECTION = 'member-tasks';
export const EMAIL_EDITOR_SECTION = 'email-editor';

export const EmailViewSections = () => {
  const [currentSection, setCurrentSection] = useState(EMAIL_EDITOR_SECTION);

  const {
    selectedClientActionItemMap,
    selectedPlannerActionItemMap,
    plannerActionItems,
    clientActionItems,
  } = useEmailTabContext();

  const memberTaskCount = Object.keys(selectedClientActionItemMap).length;
  const plannerTaskCount = Object.keys(selectedPlannerActionItemMap).length;

  return (
    <>
      <div
        style={{
          display: currentSection === EMAIL_EDITOR_SECTION ? 'block' : 'none',
          height: '100%',
        }}
      >
        <EmailEditorSection setCurrentSection={setCurrentSection} />
      </div>
      <div
        style={{
          display: currentSection === ATTACHMENTS_SECTION ? 'block' : 'none',
          height: '100%',
        }}
      >
        <AttachmentsSection setCurrentSection={setCurrentSection} />
      </div>
      <div
        style={{
          display: currentSection === MEMBER_TASKS_SECTION ? 'block' : 'none',
          height: '100%',
        }}
      >
        <TasksSection
          title={'Member tasks'}
          taskCount={memberTaskCount}
          setCurrentSection={setCurrentSection}
          selectedItemMap={selectedClientActionItemMap}
          actionItemResources={clientActionItems}
          isClientAssigned
          buttonLabel={'Add member task'}
        />
      </div>
      <div
        style={{
          display: currentSection === PLANNER_TASKS_SECTION ? 'block' : 'none',
          height: '100%',
        }}
      >
        <TasksSection
          title={'Planner tasks'}
          taskCount={plannerTaskCount}
          setCurrentSection={setCurrentSection}
          selectedItemMap={selectedPlannerActionItemMap}
          actionItemResources={plannerActionItems}
          buttonLabel={'Add action item'}
        />
      </div>
    </>
  );
};

EmailViewSections.propTypes = {
};
